module.exports = __webpack_public_path__ + "img/data2.9b553fc9.svg";